module.exports = __webpack_public_path__ + "img/jersey.7b8e6b0.webp";